/**
 * Recordings API Service
 *
 * API client functions for recording data access including
 * audio URLs for playback and recording metadata.
 */

import { apiClient } from "./api";
import type {
  RecordingResponse,
  AudioUrlResponse,
  DownloadUrlResponse,
} from "@/types/recording";

const API_PREFIX = import.meta.env.VITE_API_V1_PREFIX || "/api/v1";

/**
 * Get recording details by ID
 */
export async function getRecording(
  recordingId: string
): Promise<RecordingResponse> {
  const response = await apiClient.get(
    `${API_PREFIX}/recordings/${recordingId}`
  );
  return response.data;
}

/**
 * Get recording for a reflection
 */
export async function getRecordingForReflection(
  reflectionId: string
): Promise<RecordingResponse | null> {
  const response = await apiClient.get(
    `${API_PREFIX}/reflections/${reflectionId}/recording`
  );
  return response.data;
}

/**
 * Get presigned audio URL for playback
 */
export async function getAudioUrl(
  recordingId: string
): Promise<AudioUrlResponse> {
  const response = await apiClient.get(
    `${API_PREFIX}/recordings/${recordingId}/audio-url`
  );
  return response.data;
}

/**
 * Get presigned download URL for audio file
 */
export async function getDownloadUrl(
  recordingId: string
): Promise<DownloadUrlResponse> {
  const response = await apiClient.get(
    `${API_PREFIX}/recordings/${recordingId}/download-url`
  );
  return response.data;
}
